import React from 'react';
import { useParams } from 'react-router-dom';
import { useGetMobilityQuery } from '../../../api/queries/getMobility';
import LoadingElement from '../../../components/LoadingElement';
import NotFoundResult from '../../../components/results/NotFoundResult';
import MobilityDetailsInnerPage from './MobilityDetailsInnerPage';

const MobilityDetailPage = () => {
    const { mobilityId } = useParams<{ mobilityId: string }>();

    const { data, loading } = useGetMobilityQuery({
        fetchPolicy: 'network-only',
        variables: { id: mobilityId },
    });

    const mobility = data?.event;

    if (!mobility && loading) {
        return <LoadingElement />;
    }

    if (!mobility) {
        return <NotFoundResult />;
    }

    return <MobilityDetailsInnerPage mobility={mobility} />;
};

export default MobilityDetailPage;
